import { IModelBase } from 'common-components'
import { Injectable } from '@angular/core'
import { ODataConfiguration } from '@exchange/services/core/odata'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export interface IControlTooltip extends IModelBase {
  Form: string
  Uid: string
  Title: string
  Text: string
}

@Injectable()
export class ControlTooltipODataService extends ODataService<IControlTooltip> {
  constructor(
    protected http: HttpClient,
    protected config: ODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'ControlTooltips'
  }
}
